import FullScreenLoader from "../components/utils/FullScreenLoader"
import { MySelector } from "../redux/store"
import { getDesignHeadingFontClass } from "../gallery-designs/registry"

const About = () => {
  const { data } = MySelector((state) => state.event)
  // Use the active design's display font (falls back to Lora for default).
  const headingFont = getDesignHeadingFontClass(data?.galleryTheme) || "font-lora"

  if (!data?.description) return <FullScreenLoader />

  return (
    <div className="flex flex-col flex-1 justify-center items-center mt-[70px] lg:mt-0">
      <div className="h-0.5 w-1/2 lg:w-1/6 bg-newOffBlack dark:bg-golden" />
      <p className={`text-newDarkBlack dark:text-offWhite lg:font-[500] ${headingFont} px-5 lg:px-0 lg:w-2/3 text-center lg:text-2xl leading-[30px] lg:leading-[47.28px] my-10 lg:my-20`}>
        “{data?.description}”
      </p>
      <div className="h-0.5 w-1/2 lg:w-1/6 bg-newOffBlack dark:bg-golden" />
    </div>
  )
}

export default About
